<template>
  <v-app id="app"
    v-bind:class="[{'he': $i18n.locale=='he' },{'en': $i18n.locale!='he'}]"
    :style="{background: $vuetify.theme.themes[theme].background}"
    >
  <Navbar />

    <v-content class="ma-4">
     <router-view />
    </v-content>
    <Confirm ref="confirm"></Confirm>
    <globalSnackbar ref="globalSnackbar"></globalSnackbar>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import Confirm from "./components/Confirm";
import globalSnackbar from "./components/GlobalSnackbar";

export default {
  name: "App",
  components: {
    Navbar,
    Confirm,
    globalSnackbar
  },
  data: () => ({
    //
  }),

  created () {
    this.$vuetify.theme.dark = true
    this.$store.dispatch("actionSetSelectedDays", [1,2,3,4,5,6,7]);

    //get locale from cookie
    let _cookie = "; " + document.cookie;
    let parts = _cookie.split("; locale=");
    if (parts.length == 2)
      this.$root.$i18n.locale = parts.pop().split(";").shift();
    //adjust rtl if hebrew
    if (this.$root.$i18n.locale == 'he') {
      this.$vuetify.rtl = true;
    }
    else {
      this.$vuetify.rtl = false;
    }
  //read stored theme
    parts = _cookie.split("; theme=");
    if (parts.length == 2) {
      const _theme = parts.pop().split(";").shift();
      this.$vuetify.theme.dark = _theme.toLowerCase() == "dark"
    }



  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$globalSnackbar = this.$refs.globalSnackbar.open;
    if (process.env.NODE_ENV == "development")
      this.$store.dispatch("loginUser", {email: "ronmany@gmail.com", password: "Rm12345%"});   //TODO: Remove this line (for debug only)
  },
  computed:{
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>

<style>
  @import url("https://fonts.googleapis.com/css?family=Pacifico");
  .en {
    direction: ltr;
  }
  .he {
    direction: rtl;
  }

</style>